import { buildClassesHook } from '../../../helpers/styles';

export const useClasses = buildClassesHook({
    LoadSummaryRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
});
